import { render, staticRenderFns } from "./Contanct.vue?vue&type=template&id=e2938454&scoped=true"
import script from "./Contanct.vue?vue&type=script&lang=js"
export * from "./Contanct.vue?vue&type=script&lang=js"
import style0 from "./Contanct.vue?vue&type=style&index=0&id=e2938454&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2938454",
  null
  
)

export default component.exports